module.exports = __webpack_public_path__ + "static/hob-f110da520c4cb7e6ab69f4c0c402d0d1.jpg";